const ponyFills = {
    // replicates classList.toggle functionality, IE11 does not support the second argument
    classToggle : ( el, className, condition ) => {
        if ( condition ) {
            el.classList.add( className );
        } else {
            el.classList.remove( className );
        }
    },
};

const toggleClass = ponyFills.classToggle;

export { ponyFills as default, toggleClass };
